<template>
  <div class="popup-overlay" @click.self="$emit('close')">
    <div class="popup-content">
      <button @click="$emit('close')" class="close-button">
        <i class="fas fa-times"></i>
      </button>
      <h2>User Details</h2>
      <UserDetails :user="user" :index="index" @copy="$emit('copy')" />
    </div>
  </div>
</template>

<script>
import UserDetails from './UserDetails.vue';

export default {
  name: 'PopupOverlay',
  components: {
    UserDetails,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  emits: ['close', 'copy'],
};
</script>

<style scoped>
.popup-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 1000;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background-color: var(--card-background);
  padding: 30px;
  border-radius: 15px;
  max-width: 80%;
  max-height: 80%;
  overflow-y: auto;
  position: relative;
  box-shadow: var(--card-shadow);
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  color: var(--text-color);
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.close-button:hover {
  color: var(--primary-color);
}

h2 {
  color: var(--secondary-color);
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .popup-content {
    width: 90%;
    max-height: 90%;
  }
}
</style>

